import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ConceptoFacturaEdit } from "./edit";
const EditModal = ConceptoFacturaEdit;
type Entity = models.ConceptoFactura;
export interface Props {
    value: Entity[];
    onChange: (value: Entity[]) => PromiseLike<void> | void;
    readonly?: boolean;
    personaMoral: boolean;
    MasDecimales: boolean;
}

//TODO: Hacer estos calculos en el backend y ponerlos en un ConceptoDTO

function subtotal(concepto: Entity) {
    const value = concepto;
    const unitario = value.PrecioUnitario ? value.PrecioUnitario : 0;
    const cantidad = value.Cantidad ? value.Cantidad : 0;
    return unitario * cantidad;
}

function total(concepto: Entity) {
    const value = concepto;
    const totalImpuestos = impuestos(concepto);
    return subtotal(value) + totalImpuestos;
}

function totalMorales(concepto: Entity) {
    const value = concepto;
    const totalImpuestos = impuestos(concepto);
    const totalRetenciones = retenciones(concepto);
    return subtotal(value) + totalImpuestos - totalRetenciones;
}

function impuestos(concepto: Entity) {
    const value = concepto;
    const iva = value.TasaIva ? value.TasaIva : 0;
    const ieps = value.TasaIeps ? value.TasaIeps : 0;
    const totalIva = subtotal(value) * iva;
    const totalIeps = subtotal(value) * ieps;    
    return totalIva + totalIeps;
}

function retenciones(concepto: Entity) {
    const value = concepto;
    const ivaRetencion = value.TasaRetencionIva ? value.TasaRetencionIva : 0;
    const totalRetencion = subtotal(value) * ivaRetencion;
    return totalRetencion;
}

function FormatoMoneda(x: Number) {
    return "$"+(x.toFixed(6));
}

const columnasFijas: kea.Grid2Column<Entity>[] = [
    { title: "Descripcion", cell: x => ({ data: x.Descripcion }) },
    { title: "Cantidad", cell: x => ({ data: x.Cantidad }) },
    { title: "Precio unitario", cell: x => ({ data: kea.formatCurrency(x.PrecioUnitario) }) },
    { title: "Subtotal", cell: x => ({ data: kea.formatCurrency(subtotal(x)) }) },
    { title: "Impuestos", cell: x => ({ data: kea.formatCurrency(impuestos(x)) }) },
    { title: "Retenciones", cell: x => ({ data: kea.formatCurrency(retenciones(x)) }) },
    { title: "Total", cell: x => ({ data: kea.formatCurrency(totalMorales(x)) }) },
];

const columnasFijasMasDecimales: kea.Grid2Column<Entity>[] = [
    { title: "Descripcion", cell: x => ({ data: x.Descripcion }) },
    { title: "Cantidad", cell: x => ({ data: x.Cantidad }) },
    { title: "Precio unitario", cell: x => ({ data: kea.formatCurrency(x.PrecioUnitario) }) },
    { title: "Subtotal", cell: x => ({ data: kea.formatCurrency(subtotal(x)) }) },
    
    { title: "Impuestos", cell: x => ({ data: FormatoMoneda(impuestos(x)) }) },
    { title: "Retenciones", cell: x => ({ data: FormatoMoneda(retenciones(x)) }) },
    { title: "Total", cell: x => ({ data: FormatoMoneda(totalMorales(x)) }) },
];


export interface BotonesDeps {
    onBorrar: (item: Entity) => void;
    onEdit: (item: Entity) => void;
}

function botones(deps: BotonesDeps, soloLectura: boolean): kea.Grid2Column<Entity, undefined> {
    return kea.columnaBotones<Entity>([
        {
            tooltip: "Modificar concepto",
            style: "primary",
            iconClass: fa("pencil"),
            disabled: x => soloLectura,
            onClick: deps.onEdit
        }, {
            tooltip: "Eliminar concepto",
            style: "danger",
            iconClass: fa("trash-o"),
            disabled: x => soloLectura,
            onClick: deps.onBorrar
        }
    ]);
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps, soloLectura: boolean, MasDecimales: boolean): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps, soloLectura), ...  ( MasDecimales ? columnasFijasMasDecimales :columnasFijas ) ];
}

/**Establece las propiedades de descripcion para ser mostradas correctamente en el listado */
async function setDescripciones(x: Entity): Promise<Entity> {
    return x;
}

/**
* Listado de ConceptoFactura
*/
class ConceptoFacturaListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();
    onAgregar = async () => {
        var esPersonaMoral = this.props.personaMoral;
        const result = await this.modals.showModal(EditModal, esPersonaMoral, { Cantidad: 1 } as Entity);;
        if (result.result) {
            const newItem = await setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange([...oldList, newItem]);
        }
    }

    onEdit = async (item: Entity) => {
        var esPersonaMoral = this.props.personaMoral;
        const result = await this.modals.showModal(EditModal, esPersonaMoral, item);
        if (result.result) {
            const newItem = await setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange(oldList.map(x => x == item ? newItem : x));
        }
    }

    onBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", item.Descripcion);
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    onBorrarTodosConceptos = async () => {
        const ok = await kea.yesno("¿Borrar todos los conceptos?");
        
        if (ok) {
            if( this.props.value.length > 1 )
            {
                let arrayVacio : Entity[] = this.props.value.slice(0,1);
                await this.props.onChange(arrayVacio);
            }  
        }
    }

    render() {
        const cols = columnas(this, this.props.readonly!,this.props.MasDecimales);
        return (
            <div>
                <kea.Title titulo="Conceptos" />
                <div className="col-md-12">
                    <h4>
                        <div className="pull-right">
                            {
                                !this.props.readonly &&
                                <kea.AgregarButton onClick={this.onAgregar} disabled={this.props.readonly} />
                            }
                            {
                                !this.props.readonly &&
                                <kea.LimpiarButton onClick={this.onBorrarTodosConceptos} disabled={this.props.readonly} />
                            }
                        </div>
                    </h4>
                </div>

                <kea.Grid2 items={this.props.value} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}
export const ConceptoFacturaList = kea.mapProps(componentToRx(ConceptoFacturaListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/edit/componentes/conceptos/list.tsx